import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace AKCObedience {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options
      
      return show.show_elements.some(se => 
        se.show_element === elementOrLevel || se.level === elementOrLevel
      );
    };

    // Filter obedience options based on available show elements
    const obedienceOptions = [
      {
        value: Constants.dog_class_element_level.beginner_novice_a,
        id: Constants.dog_class_element_level.beginner_novice_a,
      },
      {
        value: Constants.dog_class_element_level.beginner_novice_b,
        id: Constants.dog_class_element_level.beginner_novice_b,
      },
      {
        value: Constants.dog_class_element_level.preferred_novice,
        id: Constants.dog_class_element_level.preferred_novice,
      },
      {
        value: Constants.dog_class_element_level.graduate_novice,
        id: Constants.dog_class_element_level.graduate_novice,
      },
      {
        value: Constants.dog_class_element_level.novice_a,
        id: Constants.dog_class_element_level.novice_a,
      },
      {
        value: Constants.dog_class_element_level.novice_b,
        id: Constants.dog_class_element_level.novice_b,
      },
      {
        value: Constants.dog_class_element_level.open_a,
        id: Constants.dog_class_element_level.open_a,
      },
      {
        value: Constants.dog_class_element_level.open_b,
        id: Constants.dog_class_element_level.open_b,
      },
      {
        value: Constants.dog_class_element_level.preferred_open,
        id: Constants.dog_class_element_level.preferred_open,
      },
      {
        value: Constants.dog_class_element_level.graduate_open,
        id: Constants.dog_class_element_level.graduate_open,
      },
      {
        value: Constants.dog_class_element_level.preferred_graduate_open,
        id: Constants.dog_class_element_level.preferred_graduate_open,
      },
      {
        value: Constants.dog_class_element_level.utility_a,
        id: Constants.dog_class_element_level.utility_a,
      },
      {
        value: Constants.dog_class_element_level.utility_b,
        id: Constants.dog_class_element_level.utility_b,
      },
      {
        value: Constants.dog_class_element_level.preferred_utility,
        id: Constants.dog_class_element_level.preferred_utility,
      },
      {
        value: Constants.dog_class_element_level.versatility,
        id: Constants.dog_class_element_level.versatility,
      },
      {
        value: Constants.dog_class_element_level.veteran,
        id: Constants.dog_class_element_level.veteran,
      },
      {
        value: Constants.dog_class_element_level.brace,
        id: Constants.dog_class_element_level.brace,
      },
      {
        value: Constants.dog_class_element_level.team,
        id: Constants.dog_class_element_level.team,
      },
      {
        value: Constants.dog_class_element_level.wc_novice,
        id: Constants.dog_class_element_level.wc_novice,
      },
      {
        value: Constants.dog_class_element_level.wc_open,
        id: Constants.dog_class_element_level.wc_open,
      },
      {
        value: Constants.dog_class_element_level.wc_utility,
        id: Constants.dog_class_element_level.wc_utility,
      },
      {
        value: Constants.dog_class_element_level.udx,
        id: Constants.dog_class_element_level.udx,
      },
      {
        value: Constants.dog_class_element_level.random_draw_novice,
        id: Constants.dog_class_element_level.random_draw_novice,
      },
      {
        value: Constants.dog_class_element_level.random_draw_open,
        id: Constants.dog_class_element_level.random_draw_open,
      },
      {
        value: Constants.dog_class_element_level.random_reward_utility,
        id: Constants.dog_class_element_level.random_reward_utility,
      },
    ].filter(option => isElementAvailable(option.value));

    const formRows: IEventRegisterRow[] = [];

    // Only add obedience section if there are available options
    if (obedienceOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.performance_obedience,
            multiSelect: true,
            columnLayout: true,
            multiClassMessages: {
              [Constants.dog_class_element_level.udx]: "Open B, Utility B"
            },
            options: obedienceOptions,
          },
        ],
      });
    }

    return formRows;
  };

  // Keep the original form for backward compatibility
  export const form: IEventRegisterRow[] = getForm();
}
